import React from 'react';

function COADifferentView() {
    return (
        <div>COADifferentView</div>
    );
}

export default COADifferentView;
